import { render, staticRenderFns } from "./VendorBankDetails.vue?vue&type=template&id=c1680ed8&"
import script from "./VendorBankDetails.vue?vue&type=script&lang=js&"
export * from "./VendorBankDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports